import config from '@data/config'

const { signInLink } = config

export const getSignInLink = () => {
  if (typeof window !== 'undefined') {
    return `${window.location.origin}${signInLink}`
  }
}
